module.exports = require("././angular.js");


//////////////////
// WEBPACK FOOTER
// angular (bower component)
// module id = 1026
// module chunks = 1